import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import authStore from '@/store/authStore'
import constructionSiteStore from '@/store/constructionSiteStore'
import projectFileStore from '@/store/projectFileStore'
import SecureStorage from '@/services/SecureStorage'

const debug = process.env.NODE_ENV !== 'production'
const ls = SecureStorage.get()

export default createStore({
  modules: {
    authStore,
    constructionSiteStore,
    projectFileStore
  },
  strict: debug,
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key)
      }
    })
  ]
})
